var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#f4ae95",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.807 8.958L9.713 21.965H19.83c.293 0 .558.18.673.455l.011.025a.641.641 0 01-.031.56.96.96 0 01-.835.495H8.896a.826.826 0 01-.466-.145l-.056-.038a.874.874 0 01-.29-1.09l7.19-15.149c.075-.158.182-.298.313-.41a.692.692 0 01.892-.01.497.497 0 01.135.172l7.293 15.252c.1.207.12.444.058.666a.57.57 0 01-.548.423h-.084a.877.877 0 01-.794-.516L16.249 8.96a.244.244 0 00-.22-.145.244.244 0 00-.222.143z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlt);
export default __webpack_public_path__ + "static/media/dlt.6c5d64775343b8ffe352e4e95b0fe11e.svg";
export { ForwardRef as ReactComponent };